import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-enterprise';
import {BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';
import {takeWhile} from 'rxjs/operators';
import {AlertService} from 'src/app/services/alert/alert.service';
import {LoadingService} from 'src/app/services/loading/loading.service';
import moment from 'moment';

@Component({
    selector: 'app-organization-update-message',
    templateUrl: './organization-update-message.component.html',
    styleUrls: ['./organization-update-message.component.css'],
    standalone: false
})
export class OrganizationUpdateMessageComponent implements OnInit {

  orgId: any;
  orgUpdateForm: UntypedFormGroup;
  additionalMessageResponse: any;
  redirectedFromBol: any;
  profileName: any;
  header: string;
  currentMessage: any;
  messageArray = [];
  messages: any;
  columnDefs: (ColDef | ColGroupDef)[];
  updateMessagesOptions: GridOptions = this.initializeGridOptions();
  rowData: any;
  public overlayNoRowsTemplate;
  private gridApi;

  constructor(private formBuilder: UntypedFormBuilder,
              private alertService: AlertService,
              private tmssLoader: LoadingService,
              private route: ActivatedRoute,
              private bsModalRef: BsModalRef,
              public options: ModalOptions,
  ) {
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No rows to display, please adjust your filters</span>';
    this.orgUpdateForm = this.formBuilder.group({
      newMessage: new UntypedFormControl('')
    });
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        flex: 1,
        wrapText: true,
        autoHeight: true,
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      rowData: this.messages,
      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
  }

  /**
   * initializing the ag-grid
   * @param params
   */
  onGridReady(params: any) {
    // params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    // this.gridApi.setHeaderHeight(30);
    this.gridApi.setGridOption('headerHeight', 30);
  }

  ngOnInit() {
    /* this.organizationmessagesservice.getMessages(this.orgId).subscribe(messages => {
      this.messages = messages;
      this.tmssLoader.hide();
    }, (error) => {
      this.tmssLoader.hide();
      this.alertService.error('Unable to load the message history.. Please try again later or contact system administrator');
    }); */
    // read the data from initial state //to do

    this.messages = this.options.initialState;
    this.header = this.messages.header;
    this.rowData = this.messages.messages;
    this.updateColumnDefs();
    this.profileName = this.messages.profile;
    this.tmssLoader.hide();
  }


  updateColumnDefs() {
    this.columnDefs = this.getUpdateMessagesOptionsColumnDefs();
  }

  getUpdateMessagesOptionsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        autoHeight: true,
        headerName: 'Process Type',
        field: 'processType',
        filter: 'agTextColumnFilter',
        sortable: true

      },
      {
          flex: 1,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          headerName: 'Process Type',
          field: 'processType',
          filter: 'agTextColumnFilter',
          sortable: true

        },
        {
          flex: 1,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          headerName: 'Notes',
          field: 'messageText',
          filter: 'agTextColumnFilter',
          sortable: true

        },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Updated By ',
        field: 'updateId',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Update Date ',
        field: 'updateDate',
        filter: 'agTextColumnFilter',
        sortable: true,
        cellRenderer: (data) => {
          return moment(data.value).format("MM-DD-YYYY HH:mm:ss")
        }
      }
    ];
  }

  loadMessageHistory(existingMessages) {
    /* for(let i = 0; i<existingMessages.length(); i++) {
      this.messageHistoryArray[i] = existingMessages[i].message;
    } */
  }

  /**
   * @description cancel message entered
   */
  cancelMessage() {
    // this.bsModalRef.hide();
  }

  closeModal() {
    this.bsModalRef.hide();

  }


}
